interface TabsProps {
  items: { key: string; label: string; icon?: string }[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
}

export default function Tabs({ items, value, onChange, className = '' }: TabsProps) {
  return (
    <div className={`inline-flex flex-wrap items-center gap-1 rounded-full bg-background-100 p-1 ${className}`}>
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => onChange(item.key)}
          className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-semibold transition-colors cursor-pointer ${
            value === item.key ? 'bg-primary-500 text-white' : 'text-foreground-600 hover:text-foreground-900'
          }`}
        >
          {item.icon && <i className={`${item.icon} text-base`} />}
          {item.label}
        </button>
      ))}
    </div>
  );
}